import { OutOfTermPage } from '@/components/Layout/outOfTerm'
import { isValidCampaignSlug, useCampaignSlug } from '@/core/app/useCampaignSlug'
import { AppMachineContext } from '@/core/app/useRaundLifeCycle'
import { getCampaignPeriodStatus } from '@/domain/campaign/campaignPeriod'
import { useSelector } from '@xstate/react'
import type { ReactNode } from 'react'

type CampaignPeriodGuardProps = {
  children: ReactNode
}

/**
 * キャンペーンの期間外アクセスをインターセプトして期間外メッセージを表示するガードコンポーネント。
 *
 * - campaignData が null（ライフサイクルのローディング中）のときは children をそのまま描画する
 *   → 各ページが独自のスケルトン（HomePageSkeleton 等）を表示する
 * - 期間内（active）も children をそのまま描画する
 * - 期間前（before）・期間後（after）のとき OutOfTermPage を表示する（URL は維持）
 *   → Header / BottomNavigation は表示しない
 * - キャンペーンページ以外（campaignSlug が無効）では何もせず children を返す
 * - isTestMode の値に関わらず、campaignStartAt / campaignEndAt による期間チェックを行う
 */
export function CampaignPeriodGuard({ children }: CampaignPeriodGuardProps) {
  const { campaignSlug } = useCampaignSlug()
  const appActorRef = AppMachineContext.useActorRef()
  const campaignData = useSelector(appActorRef, (s) => s.context.campaignData)

  if (!isValidCampaignSlug(campaignSlug)) {
    return <>{children}</>
  }

  const periodStatus = getCampaignPeriodStatus(campaignData)

  if (periodStatus === 'before' || periodStatus === 'after') {
    return <OutOfTermPage periodStatus={periodStatus} campaignData={campaignData} />
  }

  return <>{children}</>
}
